/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import api from 'api';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { formatNumber } from 'utils/formatting';
import * as S from './Questionnaire.styled';

export default function Business() {
    const tableName = 'Business';
    const [dataList, setData] = useState<any>();
    const params = useParams();
    const candidate_id = Number(params.id);
    useEffect(() => {
        setData(null);
        api.tableInput.fetchCandidateInput(setData, tableName, candidate_id);
    }, [candidate_id]);

    return (
        <>
            <div>
                {dataList?.map((data: any, index: number) => (
                    <span key={index}>
                        <S.Box>
                            <h4>Country</h4>
                            <h4>Region</h4>
                            <S.Value>{data?.country}</S.Value>
                            <S.Value> {data?.region}</S.Value>
                            <h4>City</h4>
                            <h4>Currently owned</h4>
                            <S.Value>{data?.city}</S.Value>
                            <S.Value> {data?.current ? 'test' : 'No'}</S.Value>
                            <h4>Start</h4>
                            <h4>End</h4>
                            <S.Value>{data?.start?.substring(4, 17)}</S.Value>
                            <S.Value>
                                {' '}
                                {data?.current ? 'Still owned' : data?.end?.substring(4, 17)}
                            </S.Value>
                            <h4>Ownership share</h4>
                            <h4>Business type</h4>
                            <S.Value>{data?.percent_ownership}%</S.Value>
                            <S.Value> {data?.type}</S.Value>
                            <h4>Number of employees</h4>
                            <h4>Annual sales in USD</h4>
                            <S.Value>{data?.number_employees}</S.Value>
                            <S.Value> {formatNumber(data?.annual_sales)}</S.Value>
                            <h4>Net profit in USD</h4>
                            <h4>Net value in USD</h4>
                            <S.Value>{formatNumber(data?.net_profit)}</S.Value>
                            <S.Value> {formatNumber(data?.net_company_value)}</S.Value>
                        </S.Box>
                    </span>
                ))}
            </div>
        </>
    );
}
